import { unstable_composeClasses as composeClasses } from "@mui/material";
import { getDetailRowUtilityClass } from "../classes.js";
function useUtilityClasses(props) {
  const { classes } = props;
  const slots = {
    root: ["root"],
    icon: ["icon"],
    label: ["label"],
    description: ["description"],
    columnLabel: ["columnLabel"],
    columnDescription: ["columnDescription"]
  };
  return composeClasses(slots, getDetailRowUtilityClass, classes);
}
export {
  useUtilityClasses
};
//# sourceMappingURL=useUtilityClasses.js.map
